export default __webpack_public_path__ + "static/media/feia_MOBILE.3750d5c7.png";